<template>
    <div class="generator__panel">
        <div class="panel-animation">
            <div class="panel-buttons">
                <div @click="selectNoKudos"
                     class="no-kudos"
                     :class="wallpaper.kudos == null ? 'is-active' : ''"
                >
                    <img src="../../assets/no-kudos.svg">
                </div>
            </div>
        </div>
        <div v-bar class="panel-content kudos">
            <div class="panel-content__scroll">
                <ul class="kudos__list">
                    <appkudos v-for="(item, index) in kudos"
                              :key="'kudos_' + index"
                              :item=item
                              :wallpaper=wallpaper
                              @kudosSelected="onKudosSelect"
                    >
                    </appkudos>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import Kudos from '../../data/kudos';
    import KudosItem from '../panels/KudosItem';


    export default {
        components: {
            appkudos: KudosItem
        },
        props: ['wallpaper'],
        data() {
            return {
                kudos: Kudos
            }
        },
        methods: {
            selectNoKudos() {
                this.wallpaper.kudos = null;
                this.eventHub.$emit('kudosSelected');
            },
            onKudosSelect(kudos) {
                this.wallpaper.kudos = kudos;
                this.eventHub.$emit('kudosSelected');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .kudos {
        height: calc(100vh - 255px);

        @media(min-width: 1024px) {
            height: calc(100vh - 355px);
            position: relative;

            &:after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                background: linear-gradient(to top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
                height: 40px;
                width: 100%;
                z-index: 3
            }

            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                background: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
                height: 40px;
                width: 100%;
                z-index: 3
            }
        }

        &__item {
            margin-bottom: 24px;
            margin-right: 24px;

            &:nth-child(2n) {
                margin-right: 0;
            }
            width: calc(50% - 12px);

            @media (min-width: 768px) {
                width: calc(33.33% - 16px);

                &:nth-child(2n) {
                    margin-right: 24px;
                }

                &:nth-child(3n) {
                    margin-right: 0;
                }

                &:nth-child(-n+3) {
                    margin-top: 20px;
                }
            }
        }
    }

    .no-kudos {
        border: 1px solid rgba(255, 255, 255, 0.16);
        border-radius: 4px;
        cursor: pointer;
        display: inline-block;
        height: 40px;
        transition: border .2s linear;

        &:hover, &.is-active {
            border: 1px solid rgba(255, 255, 255, 1);
        }

        img {
            height: 13px;
            margin: 14px 10px 0 10px;
            width: auto;
        }
    }

    .panel-buttons {
        display: flex;
        height: 40px;
        margin-bottom: 21px;
    }
</style>


// WEBPACK FOOTER //
// src/components/panels/Kudos.vue